var _g, _path, _path2, _path3, _path4, _g2, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollateralImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 256,
    viewBox: "0 0 264 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_51_19415)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.5127,
    y: 16.7576,
    width: 170.15,
    height: 162.631,
    rx: 4,
    fill: "url(#paint0_linear_51_19415)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.483 83.0806L208.683 149.585V189.487L155.483 122.983V83.0806Z",
    fill: "#B4ABEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.685 149.594L155.662 216.098V256L208.685 189.496V149.594Z",
    fill: "url(#paint1_linear_51_19415)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.8 83.0806L264 149.585V189.487L210.8 122.983V83.0806Z",
    fill: "#B4ABEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.001 149.594L210.979 216.098V256L264.001 189.496V149.594Z",
    fill: "url(#paint2_linear_51_19415)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_51_19415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4447 14.413C21.8004 28.6263 14.9647 58.505 29.1794 81.1496C43.3941 103.794 73.2638 110.629 95.9082 96.416C118.552 82.2028 125.388 52.324 111.174 29.6794C96.9588 7.03602 67.0891 0.200975 44.4447 14.413Z",
    fill: "url(#paint3_radial_51_19415)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.114 58.7814C137.114 55.739 106.644 53.2727 69.057 53.2727C31.4702 53.2727 1 55.739 1 58.7814",
    stroke: "url(#paint4_linear_51_19415)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_51_19415",
    x: 51.5127,
    y: 10.7576,
    width: 190.149,
    height: 182.631,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_51_19415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_51_19415",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_51_19415",
    x: 11.7646,
    y: 0,
    width: 116.824,
    height: 119.83,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_51_19415"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_51_19415",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_51_19415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_19415",
    x1: 241.021,
    y1: 260.705,
    x2: -18.2324,
    y2: -156.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_19415",
    x1: 182.173,
    y1: 292.143,
    x2: 182.173,
    y2: 121.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B86E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_19415",
    x1: 237.49,
    y1: 292.143,
    x2: 237.49,
    y2: 121.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B86E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D1DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_51_19415",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0536 97.3745) rotate(-58.1931) scale(108.616 108.612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF89E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#92D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991368,
    stopColor: "#89A7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_19415",
    x1: -18.6096,
    y1: 59.8831,
    x2: 216.641,
    y2: 46.6019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.557292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B4DF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollateralImage);
export default __webpack_public_path__ + "static/media/collateral-image.463fcc40960cf98537104117f1b3cec1.svg";
export { ForwardRef as ReactComponent };